import gql from "graphql-tag";

const attachmentMutations = {


    createAttachment: gql`
        mutation CreateAttachment($type_id: Int, $name: String, $path: String, $previewPDF: String, $thumbnail: String, $mime: String, $tags: String, $check_sum: String, $check_sum_consistent: DateTime, $file_id: String, $indexed: Boolean, $defective: Boolean, $defective_message: String, $next_version_id: Int, $creator_id: String, $updated_at: DateTime, $created_at: DateTime, $deleted_at: DateTime) {
            createAttachment(type_id: $type_id, name: $name, path: $path, previewPDF: $previewPDF, thumbnail: $thumbnail, mime: $mime, tags: $tags, check_sum: $check_sum, check_sum_consistent: $check_sum_consistent, file_id: $file_id, indexed: $indexed, defective: $defective, defective_message: $defective_message, next_version_id: $next_version_id, creator_id: $creator_id, updated_at: $updated_at, created_at: $created_at, deleted_at: $deleted_at) {
                id,
                type_id,
                name,
                path,
                previewPDF,
                thumbnail,
                mime,
                tags,
                check_sum,
                check_sum_consistent,
                file_id,
                indexed,
                defective,
                defective_message,
                next_version_id,
                creator_id,
                updated_at,
                created_at,
                deleted_at
            }
        }
    `,
    updateAttachment: gql`
        mutation UpdateAttachment($id: ID!, $type_id: Int, $name: String, $path: String, $previewPDF: String, $thumbnail: String, $mime: String, $tags: String, $check_sum: String, $check_sum_consistent: DateTime, $file_id: String, $indexed: Boolean, $defective: Boolean, $defective_message: String, $next_version_id: Int, $creator_id: String, $updated_at: DateTime, $created_at: DateTime, $deleted_at: DateTime) {
            updateAttachment(id: $id, type_id: $type_id, name: $name, path: $path, previewPDF: $previewPDF, thumbnail: $thumbnail, mime: $mime, tags: $tags, check_sum: $check_sum, check_sum_consistent: $check_sum_consistent, file_id: $file_id, indexed: $indexed, defective: $defective, defective_message: $defective_message, next_version_id: $next_version_id, creator_id: $creator_id, updated_at: $updated_at, created_at: $created_at, deleted_at: $deleted_at) {
                id,
                type_id,
                name,
                path,
                previewPDF,
                thumbnail,
                mime,
                tags,
                check_sum,
                check_sum_consistent,
                file_id,
                indexed,
                defective,
                defective_message,
                next_version_id,
                creator_id,
                updated_at,
                created_at,
                deleted_at
            }
        }
    `,
};

export default attachmentMutations;